function doAnimations() {
    const windowBottom = window.scrollY + window.innerHeight;

    const elements = document.querySelectorAll(".animatable-js");

    console.log(elements.length);

    elements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const elTop = rect.top + window.scrollY;
        const elHeight = rect.height;

        if (elTop + elHeight - 20 < windowBottom) {
            el.classList.remove("animatable-js");
            el.classList.add("animated-js");
        }
    });
}

document.addEventListener("DOMContentLoaded", () => {
    doAnimations();
    window.addEventListener("scroll", doAnimations);
});


// ── Typewriter ────────────────────────────────
function initType(el) {
  const text = el.getAttribute('data-text') || el.textContent;
  el.innerHTML = '';
  el.classList.remove('done');
  [...text].forEach((ch, i) => {
    const s = document.createElement('span');
    s.className = 'char';
    s.textContent = ch;
    s.style.animationDelay = (i * 42) + 'ms';
    el.appendChild(s);
  });
  setTimeout(() => el.classList.add('done'), text.length * 42 + 200);
}

// ── Mot par mot ───────────────────────────────
function initWords(el) {
  const words = el.textContent.trim().split(' ');
  el.innerHTML = '';
  words.forEach((w, i) => {
    const wrap  = document.createElement('span');
    wrap.className = 'word';
    const inner = document.createElement('span');
    inner.className = 'word-inner';
    inner.textContent = w;
    inner.style.animationDelay = (i * 120) + 'ms';
    wrap.appendChild(inner);
    el.appendChild(wrap);
    if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
  });
}

// ── Lettres éparpillées ───────────────────────
function initScatter(el) {
  const text = el.textContent.trim();
  el.innerHTML = '';
  [...text].forEach((ch, i) => {
    const s = document.createElement('span');
    s.className = 'char';
    s.textContent = ch;
    if (ch === ' ') { s.style.marginRight = '.25em'; return el.appendChild(s); }
    s.style.setProperty('--sx', ((Math.random() - .5) * 60) + 'px');
    s.style.setProperty('--sy', ((Math.random() - .5) * 40) + 'px');
    s.style.setProperty('--sr', ((Math.random() - .5) * 30) + 'deg');
    s.style.animationDelay = (i * 35) + 'ms';
    el.appendChild(s);
  });
}

// ── Count up ──────────────────────────────────
function initCount(el) {
  const from   = +el.getAttribute('data-from') || 0;
  const to     = +el.getAttribute('data-to')   || 100;
  const suffix = el.getAttribute('data-suffix') || '';
  const dur    = 1200;
  const start  = performance.now();
  (function step(now) {
    const p    = Math.min((now - start) / dur, 1);
    const ease = 1 - Math.pow(1 - p, 3);
    el.textContent = Math.round(from + (to - from) * ease).toLocaleString('fr-FR') + suffix;
    if (p < 1) requestAnimationFrame(step);
  })(start);
}